import { createFileRoute } from "@tanstack/react-router";

import { Planning } from "./-components/planning";
import { ProposeGoalCard } from "./-components/propose-goal-card";

export const Route = createFileRoute(
  "/_user/coaching/$engagementId/coaching-goals-and-outcomes",
)({
  staticData: { title: "Coaching Goals" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();

  return (
    <div className="min-h-engagement-card space-y-6">
      <Planning engagementId={engagementId} />
      <ProposeGoalCard engagementId={engagementId} />
    </div>
  );
}
